import React, { useState } from "react"
import { H1 } from "../Styles/TextStyles"
import getFirebase from "../../firebase"
import firebase from "firebase"
import styled from "styled-components"
import TotalAuthView from "./TotalAuthView"

export default function FinalView() {
  var [signedIn, isSignedIn] = useState(false)

  const checkAuth = async () => {
    try {
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          signedIn = true
        } else {
          signedIn = false
        }
      })
    } catch (error) {
      console.log("error", error)
    }
  }
  return (
    <Wrapper>
      {/* {isSignedIn === true && <UserProfile />}
      {isSignedIn === false && <TotalAuthView />} */}
      <H1>HI My Name is Final Auth Page</H1>
    </Wrapper>
  )
}

const Wrapper = styled.div``
